import type { PropsWithChildren } from 'react'
import { SkeletonBlock } from '~/shared/ui/skeleton-block'

export function LoadingSkeleton({ children }: PropsWithChildren) {
  return (
    <>
      <div className="border-divider bg-surface-lowest flex h-[72px] shrink-0 items-center justify-between border-b px-2">
        <SkeletonBlock className="ml-[42px] h-8 w-[226px]" />

        <div className="flex items-center">
          <div className="flex items-center">
            <SkeletonBlock className="mr-2 size-6 rounded-full" />
            <SkeletonBlock className="h-5 w-[60px]" />
          </div>

          <SkeletonBlock className="mr-2 ml-1 h-px w-[60px]" />

          <div className="flex items-center">
            <SkeletonBlock className="mr-2 size-6 rounded-full" />
            <SkeletonBlock className="h-5 w-[100px]" />
          </div>

          <SkeletonBlock className="mr-2 ml-1 h-px w-[60px]" />

          <div className="flex items-center">
            <SkeletonBlock className="mr-2 size-6 rounded-full" />
            <SkeletonBlock className="h-5 w-[100px]" />
          </div>

          <SkeletonBlock className="mr-2 ml-1 h-px w-[60px]" />

          <div className="flex items-center">
            <SkeletonBlock className="mr-2 size-6 rounded-full" />
            <SkeletonBlock className="h-5 w-[120px]" />
          </div>
        </div>
        <div className="h-full w-[150px]" />
      </div>
      <div className="h-full w-full">{children}</div>
    </>
  )
}
